// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"3be8a502","558":"32dadc93","866":"32dadc93","918":"6f46d8ba"}[chunkId] + ".chunk.css";
};